var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdminBadge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_4748_9183)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.98113 2.16038L12 0.5L15.0189 2.16038V5.21197L17.1768 3.05408L20.4855 4.01467L21.4461 7.3234L19.2884 9.48113H22.3396L24 12.5L22.3396 15.5189H19.2886L21.4463 17.6765L20.4857 20.9852L17.1769 21.9458L15.0189 19.7878V22.8396L12 24.5L8.98113 22.8396V19.7884L6.82365 21.9458L3.51492 20.9852L2.55433 17.6765L4.71197 15.5189H1.66038L0 12.5L1.66038 9.48113H4.71223L2.5545 7.3234L3.5151 4.01467L6.82383 3.05408L8.98113 5.21138V2.16038Z",
    fill: "url(#paint0_radial_4748_9183)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9135 9.37339C17.2419 9.75054 17.2152 10.3342 16.854 10.6771L11.3215 15.9284L7.92975 11.828C7.61066 11.4422 7.65151 10.8594 8.02097 10.5263C8.39044 10.1931 8.94862 10.2358 9.2677 10.6215L11.4741 13.289L15.6648 9.31131C16.0261 8.96844 16.5851 8.99624 16.9135 9.37339Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_4748_9183",
    x: 0,
    y: 0.5,
    width: 24,
    height: 24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.65
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.620678 0 0 0 0 0.749007 0 0 0 0 0.991406 0 0 0 0.46 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4748_9183"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4748_9183",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.1348 12.6348) rotate(90.6511) scale(11.8659)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C95FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2EDFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminBadge);
export default __webpack_public_path__ + "static/media/adminBadge.389cf0130eb87009b88ad240315c258d.svg";
export { ForwardRef as ReactComponent };